import React, { forwardRef } from 'react'

import { IconProps } from './types'

const FileText = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.99998 8.66667H7.99998M5.99998 11.3333H10.3333M8.66665 2.66667V6H12M3.33331 2H8.66665L12.6666 6V14H3.33331V2Z"
        stroke={color || 'currentColor'}
        strokeLinecap="square"
      />
    </svg>
  ),
)
FileText.displayName = 'FileText'

export default FileText
